import React from "react";
import { colors, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme: any) => ({
    root: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      width: "100%",
      padding: 0,
      margin: 0,
      backgroundColor: "#fff",
      overflowX: "auto",
    },
    customLink: {
      "& a": {
        display: "inline-block",
        padding: "6px 14px 6px 14px",
        borderRadius: 4,
        color: colors.common.white,
        backgroundColor: theme.palette.secondary.main,
        textDecoration: "none",
        fontSize: "0.88rem",

        "&:hover": {
          opacity: 0.9,
          textDecoration: "none",
        },
      },
    },
      appNameTitle: {
        fontWeight: theme.typography.fontWeightBold
      },
    wrapper: {
      textAlign: "center",
    },
    title: {
      fontSize: "4.6rem !important",
      color: theme.palette.grey[800],
    },
    subTitle: {
      color: theme.palette.grey[800],
    },
    description: {
      fontSize: "0.84rem !important",
      width: "100% !important",
      color: theme.palette.grey[600],
    },
  }),
  {
    name: "errors-page-style",
    flip: null,
  }
);
